import { chunk } from 'lodash';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import './landing.css';
import { LandingProps, MentorProfile } from '../../types/pages/Landing';
import MentorCard from './MentorCard';
import PageFrameGeneric from '../../common/page-frames/generic';

import { DataLoadStatus } from '../../types';

@inject('landingStore', 'userStore')
@observer
class Landing extends React.Component<LandingProps> {
  public async componentDidMount() {
    const store = this.props.landingStore!;
    if (store.loadStatus === DataLoadStatus.NOT_STARTED) {
      await store.fetchMentors();
    }
  }

  public render() {
    let unknownUserPrompt;
    let styles;
    if (!this.props.userStore!.isSignedIn) {
      unknownUserPrompt = this.unknownUserPrompt();
      styles = {
        marginBottom: '2rem',
        marginTop: '10%'
      };
    }

    return (
      <PageFrameGeneric className="landing" title="Mentor In Tech">
        <section className="hero is-large">
          <div className="hero-body">
            <div className="container" style={styles}>
              <h1 className="title">
                Looking for a change?
              </h1>
              <h2 className="subtitle">
                Let's bootstrap your next adventure.
              </h2>

              {unknownUserPrompt}
            </div>
          </div>
        </section>
        
        <section className="section mentors">
          <div className="container">
            <div className="columns is-centered">
              <h1 className="title">
                Meet Our Mentors
              </h1>
            </div>

            {this.renderMentorTiles()}
          </div>
        </section>
      </PageFrameGeneric>
    );
  }

  private renderMentorTiles() {
    // Group the mentor list into groups of 3
    const mentorList: MentorProfile[][] = chunk(this.props.landingStore!.mentorProfiles, 3);
    return mentorList.map((mentorGroup, groupIndex) =>
        <div className="columns" key={groupIndex}>
          {
            mentorGroup.map((mentor, mentorIndex) =>
              <div className="column is-4" key={mentorIndex}>
                <MentorCard mentor={mentor} />
              </div>
            )
          }
        </div>
    );
  }

  private unknownUserPrompt() {
    return (
      <div className="unkown-user-prompt">
        <div className="columns is-centered">
          <div className="column is-narrow">
            <a href="/sign-up" className="button is-outlined is-white">Get Started</a>
          </div>
        </div>
        <div className="columns is-centered contact-us-prompt">
          <div className="column is-narrow has-text-white">
            Questions?
            <span className="icon"><i className="far fa-envelope" /></span>
            <a className="has-text-white" href="mailto:info@mentorintech.com">info@mentorintech.com</a>!
          </div>
        </div>
      </div>
    )
  }
}

export default Landing;



// WEBPACK FOOTER //
// ./src/pages/landing/Landing.tsx